module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_01.988719ab.svg";